import type { OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import type { GalleryItem } from 'ng-gallery';
import { Gallery, ImageItem } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';
import { GALLERIES } from '../../../gallery.constants';

@Component({
  selector: 'app-galleries',
  templateUrl: './galleries.component.html',
  styleUrl: './galleries.component.scss',
})
export class GalleriesComponent implements OnInit {
  // Duplikálás a design miatt
  protected readonly galleries = [...GALLERIES, ...GALLERIES];
  protected readonly galleryId = 'myLightbox';
  protected items: GalleryItem[] = [];
  readonly #lightbox = inject(Lightbox);
  readonly #galleryRef = inject(Gallery).ref(this.galleryId);

  ngOnInit(): void {
    // Set items array
    this.items = [
      new ImageItem({
        src: 'multimedia/galleries/2023/szebit2023_1_of_217.webp',
        thumb: 'multimedia/galleries/2023/szebit2023_1_of_217.webp',
      }),
      new ImageItem({
        src: 'multimedia/galleries/2023/szebit2023_3_of_217.webp',
        thumb: 'multimedia/galleries/2023/szebit2023_3_of_217.webp',
      }),
    ];

    this.#galleryRef.setConfig({ thumbs: true });
  }

  protected openInFullScreen(index: number): void {
    this.items = this.galleries[index].images.map(
      fileName =>
        new ImageItem({
          src: `multimedia/galleries/${this.galleries[index].year}/${fileName}`,
          thumb: `multimedia/galleries/${this.galleries[index].year}/${fileName}`,
        }),
    );
    this.#galleryRef.load(this.items);

    this.#lightbox.open(0, this.galleryId, {
      panelClass: 'fullscreen',
    });
  }
}
